import { useTranslation } from 'react-i18next'

import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import Alert from '@mui/material/Alert'

import WeeklyScheduleBuilder from '../components/WeeklyScheduleBuilder'

export default function ScheduleStep() {
  const { t } = useTranslation()

  return (
    <Stack spacing={3}>
      <Stack spacing={0.5}>
        <Typography variant="h6">
          {t('page.meetingLink.wizard.schedule.title', 'When are you available?')}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {t('page.meetingLink.wizard.schedule.subtitle', 'Set your recurring weekly schedule')}
        </Typography>
      </Stack>

      <WeeklyScheduleBuilder />

      <Alert severity="info" variant="outlined">
        {t('page.meetingLink.wizard.schedule.hint', 'Pre-filled with common office hours. Toggle days on/off and adjust times.')}
      </Alert>
    </Stack>
  )
}
